const PUBLIC_BASE = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const VIDEO_PATH = `${PUBLIC_BASE}/video`;

export const getDemoTabs = (language) => [
  {
    id: "mapa",
    label: language === "es" ? "Tracking" : "Tracking",
    title: language === "es" ? "Tracking" : "Tracking",
    videoBase: `${VIDEO_PATH}/TraficoNacional`,
    text:
      language === "es"
        ? "Ubicación minuto a minuto, historial y estado operativo en una sola vista."
        : "Minute-by-minute location, history, and operational status in one view.",
    bullets:
      language === "es"
        ? ["Geocercas inteligentes", "Eventos por regla", "Filtro por flota"]
        : ["Smart geofences", "Rule-based events", "Fleet filters"],
  },
  {
    id: "alertas",
    label: language === "es" ? "Alertas" : "Alerts",
    title: language === "es" ? "Alertas" : "Alerts",
    videoBase: `${VIDEO_PATH}/AlertasTrafico`,
    text:
      language === "es"
        ? "Detección inmediata de aperturas, desvíos y paradas no autorizadas."
        : "Immediate detection of opens, deviations and unauthorized stops",
    bullets:
      language === "es"
        ? ["Notificaciones en tiempo real", "Escalamiento por prioridad", "Bitácora"]
        : ["Real-time notifications", "Priority escalation", "Logbook"],
  },
  {
    id: "reporte",
    label: language === "es" ? "Tracking Global" : "Global Tracking",
    title: language === "es" ? "Tracking Global" : "Global Tracking",
    videoBase: `${VIDEO_PATH}/TraficoInternacional`,
    text:
      language === "es"
        ? "Trazabilidad total de origen a destino."
        : "Complete traceability from origin to destination.",
    bullets:
      language === "es"
        ? ["Histórico por viajes", "Registros fotográficos en cada evento", "Soporte para auditoría"]
        : [
          "Trip history",
          "Photographic records for each event",
          "Audit support"
        ],
  },
];

export const getModules = (language) => [
  {
    title: language === "es" ? "Tracking en tiempo real" : "Real-time tracking",
    subtitle:
      language === "es"
        ? "Mapa vivo, historial y eventos por regla."
        : "Live map, history, and rule-based events.",
    bullets:
      language === "es"
        ? ["Geocercas dinámicas", "Alertas operativas", "Historial por activo"]
        : ["Dynamic geofences", "Operational alerts", "Asset history"],
    stat: {
      value: 98,
      suffix: "%",
      label: language === "es" ? "Cumplimiento" : "Compliance",
    },
    progress: 92,
  },
  {
    title: language === "es" ? "Reportes y analítica" : "Reports & analytics",
    subtitle:
      language === "es"
        ? "Reportes listos, programados y exportables."
        : "Ready, scheduled, and exportable reports.",
    bullets:
      language === "es"
        ? ["KPIs por ruta", "Programación automática", "Exportación CSV/PDF"]
        : ["KPIs by route", "Auto scheduling", "CSV/PDF export"],
    stat: {
      value: 240,
      suffix: "K",
      label: language === "es" ? "Registros / mes" : "Records / month",
    },
    progress: 86,
  },
  {
    title: language === "es" ? "Formularios en campo" : "Field forms",
    subtitle:
      language === "es"
        ? "Checklists con evidencia y trazabilidad."
        : "Checklists with evidence and traceability.",
    bullets:
      language === "es"
        ? ["Fotos y firmas", "Incidencias", "Campos obligatorios"]
        : ["Photos and signatures", "Incidents", "Required fields"],
    stat: {
      value: 4.8,
      suffix: "",
      label: language === "es" ? "Score operativo" : "Operational score",
      decimals: 1,
    },
    progress: 78,
  },
  {
    title: language === "es" ? "Rutas y despacho" : "Routes & dispatch",
    subtitle:
      language === "es"
        ? "Planeación, seguimiento y cumplimiento."
        : "Planning, tracking, and compliance.",
    bullets:
      language === "es"
        ? ["Ruteo por zonas", "Cumplimiento por ventana", "Seguimiento en vivo"]
        : ["Zone routing", "Window compliance", "Live tracking"],
    stat: {
      value: 32,
      suffix: "%",
      label: language === "es" ? "Ahorro tiempo" : "Time saved",
    },
    progress: 64,
  },
  {
    title: language === "es" ? "App móvil" : "Mobile app",
    subtitle:
      language === "es"
        ? "Para conductor y supervisor en campo."
        : "For driver and field supervisor.",
    bullets:
      language === "es"
        ? ["Recepción de tareas", "Navegación guiada", "Evidencias rápidas"]
        : ["Task reception", "Guided navigation", "Quick evidence"],
    stat: {
      value: 1200,
      suffix: "",
      label: language === "es" ? "Usuarios activos" : "Active users",
    },
    progress: 71,
  },
  {
    title: language === "es" ? "Integraciones / API" : "Integrations / API",
    subtitle:
      language === "es" ? "Conecta tu stack en minutos." : "Connect your stack in minutes.",
    bullets:
      language === "es"
        ? ["Webhooks", "ERP / BI", "SDK para partners"]
        : ["Webhooks", "ERP / BI", "Partner SDK"],
    stat: {
      value: 18,
      suffix: "",
      label: language === "es" ? "Integraciones" : "Integrations",
    },
    progress: 58,
  },
];

export const getUseCases = (language) => [
  {
    title: language === "es" ? "Transporte de carga" : "Freight transport",
    goal: language === "es" ? "Visibilidad total de recorridos" : "Full route visibility",
    metrics:
      language === "es"
        ? "Kilometraje, geocercas, temperatura"
        : "Mileage, geofences, temperature",
    evidence:
      language === "es" ? "Bitácora de eventos y alertas" : "Events and alerts log",
  },
  {
    title: language === "es" ? "Logística última milla" : "Last-mile logistics",
    goal: language === "es" ? "Cumplir SLA y reducir devoluciones" : "Meet SLA and reduce returns",
    metrics:
      language === "es"
        ? "Tiempo en ruta, puntualidad, paradas"
        : "On-route time, punctuality, stops",
    evidence:
      language === "es"
        ? "Fotos de entrega, firmas, checklists"
        : "Delivery photos, signatures, checklists",
  },
  {
    title: language === "es" ? "Servicios técnicos en campo" : "Field services",
    goal: language === "es" ? "Auditar visitas y tiempos reales" : "Audit visits and real times",
    metrics:
      language === "es"
        ? "Tiempo en sitio, llegada, cierre"
        : "On-site time, arrival, close",
    evidence: language === "es" ? "Checklist por servicio" : "Per-service checklist",
  },
  {
    title: language === "es" ? "Seguridad de mercancias" : "Assets security",
    goal:
      language === "es"
        ? "Control operacional en tiempo real"
        : "Real-time operational control",
    metrics: language === "es" ? "Paradas críticas, desvíos" : "Critical stops, deviations",
    evidence:
      language === "es"
        ? "Alertas críticas con evidencia"
        : "Critical alerts with evidence",
  },
];

export const getFaqs = (language) => [
  {
    q: language === "es" ? "¿Qué pasa si no hay señal?" : "What if there is no signal?",
    a:
      language === "es"
        ? "El dispositivo almacena eventos y sincroniza cuando recupera conectividad."
        : "The device stores events and syncs once connectivity is restored.",
  },
  {
    q: language === "es" ? "¿Qué tan preciso es?" : "How accurate is it?",
    a:
      language === "es"
        ? "Depende del dispositivo y cobertura, pero la plataforma optimiza precisión con filtros y calidad de señal."
        : "It depends on the device and coverage, but the platform improves accuracy with filters and signal quality.",
  },
  {
    q: language === "es" ? "¿Cuánto tarda la implementación?" : "How long does implementation take?",
    a:
      language === "es"
        ? "Un piloto puede estar listo en días; despliegues grandes se planifican por fases."
        : "A pilot can be ready in days; larger rollouts are planned in phases.",
  },
  {
    q: language === "es" ? "¿Puedo exportar datos?" : "Can I export data?",
    a:
      language === "es"
        ? "Sí, exportación a CSV/PDF y conexiones con BI o API."
        : "Yes, export to CSV/PDF and BI/API connections.",
  },
  {
    q: language === "es" ? "¿Soporta múltiples empresas o sedes?" : "Does it support multiple companies or sites?",
    a:
      language === "es"
        ? "Sí, con roles, permisos y separación por unidad de negocio."
        : "Yes, with roles, permissions, and business-unit separation.",
  },
];

export const getGpsBrands = (language) => [
  {
    name: "Jointech",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/Jointech.jpg`,
    info:
      language === "es"
        ? "Sellos electronicos con tracking, sensores y video."
        : "Asset tracking and monitoring.",
  },
  {
    name: "Jimi IoT",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/JimiIot.png`,
    info:
      language === "es"
        ? "Hardware GPS compatible."
        : "Compatible GPS hardware.",
  },
  {
    name: "Meitrack",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/Meitrack-website-logo.webp`,
    info:
      language === "es"
        ? "Dispositivos GPS para flotas."
        : "GPS devices for fleets.",
  },
  {
    name: "Queclink",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/Queclink.png`,
    info:
      language === "es"
        ? "Conectividad IoT y telematica."
        : "IoT connectivity and telematics.",
  },
  {
    name: "Ruptela",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/Ruptela.png`,
    info:
      language === "es"
        ? "Seguimiento de flotas."
        : "Fleet tracking.",
  },
  {
    name: "Skypatrol",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/skypatrol.jpeg`,
    info:
      language === "es"
        ? "Telematica y seguridad."
        : "Telematics and security.",
  },
  {
    name: "Suntech",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/Suntech.png`,
    info:
      language === "es"
        ? "Rastreo y control de flotas."
        : "Fleet tracking and control.",
  },
  {
    name: "Teltonika",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/Teltonika.png`,
    info:
      language === "es"
        ? "Dispositivos GPS industriales."
        : "Industrial GPS devices.",
  },
  {
    name: "Topfly",
    logo: `${process.env.PUBLIC_URL}/images/gps-Logos/topfly.png`,
    info:
      language === "es"
        ? "Monitoreo de activos."
        : "Asset monitoring.",
  },
];

export const sectionsOrder = [
  "hero",
  "recursos",
  "producto",
  "como-funciona",
  "casos",
  "tour",
  "integraciones",
  "mundo-gps",
  "seguridad",
  "precios",
  "clientes",
  "faq",
  "contacto",
];

export const translations = {
  es: {
    nav: {
      producto: "Producto",
      integraciones: "Integraciones",
      mundo: "Streaming",
      casos: "Casos",
      precios: "Precios",
      recursos: "Recursos",
      contacto: "Contacto",
    },
    buttons: {
      ingresar: "Ingresar",
      solicitarDemo: "Solicitar demo",
      verCompatibilidad: "Ver compatibilidad completa",
      verMas: "Ver más ?",
      verTourCompleto: "Solicitar Demo",
      cotizar: "Cotizar",
      hablarVentas: "Hablar con ventas",
    },
    hero: {
      badge: "Plataforma abierta · Marca blanca · Device-agnostic",
      title: "Infraestructura Inteligente de Seguridad de Carga",
      subtitle:
        "Mucho más que tracking: Computer Vision, Video Telemática y monitoreo en tiempo real para validar la integridad de contenedores, precintos y sellos, con alertas críticas y certificación digital.",
      actions: {
        integrator: "Soy integrador",
        howItWorks: "Ver cómo funciona",
      },
      tags: [
        { icon: "🏷️", label: "White Label Ready" },
        { icon: "🔌", label: "APIs abiertas" },
        { icon: "🛡️", label: "IoT Security" },
        { icon: "🤖", label: "AI + CV" },
      ],
    },
    trust: [
      { label: "Infra en la nube", strong: "Escalable y segura" },
      { label: "Disponibilidad", strong: "99.9", sub: "SLA operativo" },
      { label: "Alertas / mes", strong: "+2.3M", sub: "Eventos" },
      { label: "Activos monitoreados", strong: "+45K", sub: "Dispositivos" },
    ],
    trustSection: {
      head: "No es solo tracking. Es protección proactiva.",
      sub:
        "Diseñada para integradores, operadores y exportadores que necesitan evidencias, validación y respuesta rápida, no únicamente puntos en un mapa.",
      cards: [
        {
          title: "Computer Vision",
          text:
            "Validación automática del estado del contenedor, precintos, sellos y etiquetas en checkpoints.",
          icon: "👁️",
        },
        {
          title: "Video Telemática",
          text:
            "Video en vivo y por evento para confirmación visual inmediata cuando importa.",
          icon: "🎥",
        },
        {
          title: "Plataforma Abierta (IoT)",
          text:
            "Integración con múltiples dispositivos de seguridad y sistemas terceros mediante APIs abiertas.",
          icon: "🔗",
        },
      ],
      flow: "INSPECCIÓN ➜ VALIDACIÓN ➜ ALERTA ➜ CERTIFICACIÓN DIGITAL",
    },
    modules: {
      head: "Un ecosistema completo",
      sub: "Todo lo que necesitas para operar, auditar y escalar.",
    },
    steps: {
      head: "Cómo funciona",
      sub: "En tres pasos claros para operar desde el primer día.",
    },
    useCases: {
      head: "Casos de uso por industria",
      sub: "Elige el enfoque que más impacto genera en tu operación.",
      labels: { objetivo: "Objetivo", mide: "Qué mide", evidencia: "Evidencia" },
    },
    productAction: {
      head: "Producto en acción",
      sub: "Tour real de los módulos más usados.",
      infra: "Infra en la nube",
      vista: "Vista demo",
      precision: "Escalable y segura",
      latencia: "Disponibilidad",
      soporte: "Soporte crítico",
    },
    integrations: {
      head: "Integraciones y compatibilidad",
      sub: "Conecta dispositivos, sistemas y navegación sin fricción.",
    },
    world: {
      kicker: "Tracking 24/7",
      title: "Transmisión de video y audio para eventos críticos o en demanda ",
      copy:
        "El aseguramiento completo de un  viaje se obtiene cuando se integra la trazabilidad gps + sensores de apertura + video en tiempo real cuando sea requerido. Todo en una misma plataforma",
      pills: ["Acceso a videos históricos por viaje", "Clips de video con audio desde 30sg hasta 5 minutos", "APP para streaming desde smartphone", "Para dispositivos con cámara homologada"],
    },
    security: {
      head: "Seguridad y confiabilidad",
      sub: "Control real sin promesas vacías.",
      cards: [
        { title: "Roles y permisos", text: "Acceso granular por equipo, sede y cliente." },
        { title: "Auditoría de acciones", text: "Historial completo de cambios y accesos." },
        { title: "Gobernanza de datos", text: "Políticas ajustables según normativas internas." },
        { title: "Disponibilidad real", text: "Infra escalable con monitoreo continuo." },
      ],
    },
    pricing: {
      head: "Planes simples",
      sub: "Elige el nivel ideal para tu operación.",
      starter: {
        title: "Starter",
        price: "Desde $X / activo",
        bullets: ["Tracking esencial", "Alertas básicas", "Reportes estándar"],
      },
      pro: {
        title: "Pro",
        price: "Automatización + analítica",
        bullets: ["Reportes avanzados", "Formularios en campo", "Automatizaciones"],
      },
      enterprise: {
        title: "Enterprise",
        price: "Multi-sede + API",
        bullets: ["Integraciones avanzadas", "Soporte dedicado", "Multi-empresa"],
      },
    },
    clients: {
      head: "Nuestros clientes",
      sub: "Marcas que confían en nosotros para operar con visibilidad 24/7.",
      logos: [
        { name: "Essentia", src: `${process.env.PUBLIC_URL}/images/logo_essentia.png` },
        { name: "Mexichem", src: `${process.env.PUBLIC_URL}/images/logo_mexichem.png` },
        { name: "Summit", src: `${process.env.PUBLIC_URL}/images/logo_summit.png` },
        { name: "TMI", src: `${process.env.PUBLIC_URL}/images/logo_tmi.webp` },
        { name: "Yara", src: `${process.env.PUBLIC_URL}/images/logo_yara.png` },
        { name: "LogiSeguridad", src: `${process.env.PUBLIC_URL}/images/logo-logiseguridad.png` },
      ],
      testimonials: [
        { brand: "Essentia", rating: 4.8, quote: "Reducimos tiempos de respuesta y ganamos visibilidad operativa en minutos.", role: "CTO" },
        { brand: "Mexichem", rating: 4.9, quote: "Integración API rápida, sin fricción y soporte siempre disponible.", role: "Head de Operaciones" },
        { brand: "LogiSeguridad", rating: 5.0, quote: "Alertas críticas en tiempo real y trazabilidad completa de acciones.", role: "Director de Seguridad" },
        { brand: "Summit", rating: 4.7, quote: "La trazabilidad completa nos permitió auditar entregas y mejorar SLA.", role: "VP Logística" },
        { brand: "Yara", rating: 4.9, quote: "Alertas inteligentes que priorizan incidentes y reducen falsos positivos.", role: "Gerente de Seguridad" },
        { brand: "TMI", rating: 4.6, quote: "Integrar hardware y datos en un solo panel simplificó nuestras operaciones.", role: "COO" },
        { brand: "Cargotronics", rating: 5.0, quote: "Soporte 24/7 y evolución constante del producto según nuestras necesidades.", role: "Director TI" },
      ],
    },
    faq: {
      head: "Preguntas frecuentes",
      sub: "Resolvemos dudas típicas antes de la demo.",
    },
    final: {
      head: "Visibilidad en vivo + evidencia en campo + reportes automáticos.",
      sub:
        "Reduce tiempos muertos, mejora cumplimiento, responde incidentes más rápido.",
      list: [
        "100% integracion de procesos",
        "Sin apps sueltas ni reportes manuales",
        "Implementación guiada por expertos",
      ],
      form: {
        nombre: "Nombre",
        empresa: "Empresa",
        telefono: "Ingresar",
        correo: "Correo",
        pais: "País",
        mensaje: "Mensaje",
        paisPlaceholder: "Selecciona un país",
        nombrePlaceholder: "Tu nombre",
        empresaPlaceholder: "Tu empresa",
        telefonoPlaceholder: "+57 300 000 0000",
        correoPlaceholder: "tu@empresa.com",
        mensajePlaceholder: "Cuéntanos sobre tu operación",
      },
    },
    navAria: {
      prev: "Sección anterior",
      next: "Sección siguiente",
    },
    footer: {
      legal: "Todos los derechos reservados © 2026 Cargotronics LLC",
      politicas: "Política de privacidad",
      gdpr: "Política GDPR",
      terminos: "Términos y condiciones",
    },
  },
  en: {
    nav: {
      producto: "Product",
      integraciones: "Integrations",
      mundo: "Streaming",
      casos: "Use Cases",
      precios: "Pricing",
      recursos: "Resources",
      contacto: "Contact",
    },
    buttons: {
      ingresar: "Sign in",
      solicitarDemo: "Request demo",
      verCompatibilidad: "View full compatibility",
      verMas: "See more ?",
      verTourCompleto: "Request Demo",
      cotizar: "Get quote",
      hablarVentas: "Talk to sales",
    },
    hero: {
      badge: "Open platform · White label · Device-agnostic",
      title: "Intelligent Cargo Security Infrastructure",
      subtitle:
        "More than tracking: Computer Vision, Video Telematics, and real-time monitoring to validate the integrity of containers, seals, and locks, with critical alerts and digital certification.",
      actions: {
        integrator: "I'm an integrator",
        howItWorks: "See how it works",
      },
      tags: [
        { icon: "🏷️", label: "White Label Ready" },
        { icon: "🔌", label: "Open APIs" },
        { icon: "🛡️", label: "IoT Security" },
        { icon: "🤖", label: "AI + CV" },
      ],
    },
    trust: [
      { label: "Cloud infrastructure", strong: "Scalable and secure" },
      { label: "Availability", strong: "99.9", sub: "Operational SLA" },
      { label: "Alerts / month", strong: "+2.3M", sub: "Events" },
      { label: "Monitored assets", strong: "+45K", sub: "Devices" },
    ],
    trustSection: {
      head: "Not just tracking. Proactive protection.",
      sub:
        "Designed for integrators, operators, and exporters who need evidence, validation, and fast response—not just dots on a map.",
      cards: [
        {
          title: "Computer Vision",
          text:
            "Automatic validation of container status, seals, locks, and labels at checkpoints.",
          icon: "👁️",
        },
        {
          title: "Video Telematics",
          text:
            "Live and event-based video for immediate visual confirmation when it matters.",
          icon: "🎥",
        },
        {
          title: "Open Platform (IoT)",
          text:
            "Integration with multiple security devices and third-party systems through open APIs.",
          icon: "🔗",
        },
      ],
      flow: "INSPECTION ➜ VALIDATION ➜ ALERT ➜ DIGITAL CERTIFICATION",
    },
    modules: {
      head: "A complete ecosystem",
      sub: "Everything you need to operate, audit, and scale.",
    },
    steps: {
      head: "How it works",
      sub: "Three clear steps to operate from day one.",
    },
    useCases: {
      head: "Use cases by industry",
      sub: "Choose the focus that creates the most impact.",
      labels: { objetivo: "Goal", mide: "Measures", evidencia: "Evidence" },
    },
    productAction: {
      head: "Product in action",
      sub: "A real tour of the most used modules.",
      infra: "Cloud infraestructure",
      vista: "Demo view",
      precision: "Scalable and secure",
      latencia: "Availability",
      soporte: "Critical support",
    },
    integrations: {
      head: "Integrations & compatibility",
      sub: "Connect devices, systems, and navigation seamlessly.",
    },
    world: {
      kicker: "Tracking 24/7",
      title: "Video and audio transmission for critical or on-demand events",
      copy:
        "Complete trip security is achieved by integrating GPS tracking + door/opening sensors + real-time video when required. All in a single platform.",
      pills: ["Access to historical trip videos",
        "Video clips with audio from 30 seconds up to 5 minutes",
        "App for streaming from smartphone",
        "For devices with certified camera hardware"],
    },
    security: {
      head: "Security and reliability",
      sub: "Real control without empty promises.",
      cards: [
        { title: "Roles and permissions", text: "Granular access by team, site, and client." },
        { title: "Action auditing", text: "Complete history of changes and access." },
        { title: "Data retention", text: "Policies adjustable to internal regulations." },
        { title: "Real availability", text: "Scalable infrastructure with continuous monitoring." },
      ],
    },
    pricing: {
      head: "Simple plans",
      sub: "Choose the ideal level for your operation.",
      starter: {
        title: "Starter",
        price: "From $X / asset",
        bullets: ["Essential tracking", "Basic alerts", "Standard reports"],
      },
      pro: {
        title: "Pro",
        price: "Automation + analytics",
        bullets: ["Advanced reports", "Field forms", "Automations"],
      },
      enterprise: {
        title: "Enterprise",
        price: "Multi-site + API",
        bullets: ["Advanced integrations", "Dedicated support", "Multi-company"],
      },
    },
    clients: {
      head: "Our customers",
      sub: "Brands that trust us to run with 24/7 visibility.",
      logos: [
        { name: "Essentia", src: `${process.env.PUBLIC_URL}/images/logo_essentia.png` },
        { name: "Mexichem", src: `${process.env.PUBLIC_URL}/images/logo_mexichem.png` },
        { name: "Summit", src: `${process.env.PUBLIC_URL}/images/logo_summit.png` },
        { name: "TMI", src: `${process.env.PUBLIC_URL}/images/logo_tmi.webp` },
        { name: "Yara", src: `${process.env.PUBLIC_URL}/images/logo_yara.png` },
        { name: "LogiSeguridad", src: `${process.env.PUBLIC_URL}/images/logo-logiseguridad.png` },
      ],
      testimonials: [
        { brand: "Essentia", rating: 4.8, quote: "We cut response times and gained operational visibility in minutes.", role: "CTO" },
        { brand: "Mexichem", rating: 4.9, quote: "Fast API integration with always-on support.", role: "Head of Operations" },
        { brand: "LogiSeguridad", rating: 5.0, quote: "Real-time critical alerts with full action traceability.", role: "Security Director" },
        { brand: "Summit", rating: 4.7, quote: "End-to-end traceability helped us audit deliveries and improve SLA.", role: "VP Logistics" },
        { brand: "Yara", rating: 4.9, quote: "Smart alerts that prioritize incidents and reduce false positives.", role: "Security Manager" },
        { brand: "TMI", rating: 4.6, quote: "One panel for hardware and data streamlined our operations.", role: "COO" },
        { brand: "Cargotronics", rating: 5.0, quote: "24/7 support and a product that evolves with our needs.", role: "IT Director" },
      ],
    },
    faq: {
      head: "Frequently asked questions",
      sub: "We answer common questions before the demo.",
    },
    final: {
      head: "Live visibility + field evidence + automated reports.",
      sub: "Reduce downtime, improve compliance, and respond faster.",
      list: [
        "100% process integration",
        "No scattered apps or manual reports",
        "Expert-guided implementation",
      ],
      form: {
        nombre: "Name",
        empresa: "Company",
        telefono: "Phone",
        correo: "Email",
        pais: "Country",
        mensaje: "Message",
        paisPlaceholder: "Select a country",
        nombrePlaceholder: "Your name",
        empresaPlaceholder: "Your company",
        telefonoPlaceholder: "+1 555 000 0000",
        correoPlaceholder: "you@company.com",
        mensajePlaceholder: "Tell us about your operation",
      },
    },
    navAria: {
      prev: "Previous section",
      next: "Next section",
    },
    footer: {
      legal: "All rights reserved © 2026 Cargotronics LLC",
      politicas: "Privacy Policy",
      gdpr: "GDPR Policy",
      terminos: "Terms and Conditions",
    },
  },
};







